<template>
    <v-stepper-content step="5">
        <v-container fluid grid-list-md>
            <v-row dense>
                <v-col cols="12">
                    <v-expansion-panels v-model="posterior" color="primary">
                        <v-expansion-panel>
                            <v-expansion-panel-header v-html="'Información Adicional de Referencia'"></v-expansion-panel-header>
                            <v-expansion-panel-content v-show="tipoSeguro && objInfReferencia.productoCredito">
                                <v-card flat>
                                    <v-form ref="form_informacion_referencia">
                                        <v-card-text>
                                            <v-container fluid grid-list-md>
                                                <v-row dense>
                                                    <v-col cols="12">
                                                        <v-checkbox label="Producto con Vehículo a Crédito" color="primary"
                                                            class="mt-3" v-model="objInfReferencia.productoCredito" disabled
                                                            dense />
                                                    </v-col>
                                                </v-row>
                                                <v-row dense>
                                                    <v-col cols="12" sm="3">
                                                        <v-text-field label="Valor Vehículo Mínimo *" color="textbox"
                                                            v-model="objInfReferencia.valorVehiculoMin"
                                                            :rules="_.concat(requeridoRegla,decimal) " outlined dense />
                                                    </v-col>
                                                    <v-col cols="12" sm="3">
                                                        <v-text-field label="Valor Vehículo Máximo *" color="textbox"
                                                            v-model="objInfReferencia.valorVehiculoMax"
                                                            :rules="_.concat(requeridoRegla,decimal)" outlined dense />
                                                    </v-col>
                                                    <v-col cols="12" sm="3">
                                                        <v-text-field label="Porcentaje Valor Recomendado Mínimo *"
                                                            color="textbox"
                                                            v-model="objInfReferencia.porcValorRecomendadoMin"
                                                            :rules="_.concat(requeridoRegla,soloNumerosRegla(1,objInfReferencia.porcValorRecomendadoMin,1))"
                                                            outlined dense />
                                                    </v-col>
                                                    <v-col cols="12" sm="3">
                                                        <v-text-field label="Porcentaje Valor Recomendado Máximo *"
                                                            color="textbox"
                                                            v-model="objInfReferencia.porcValorRecomendadoMax"
                                                            :rules="_.concat(requeridoRegla,soloNumerosRegla(1,objInfReferencia.porcValorRecomendadoMax,1))"
                                                            outlined dense />
                                                    </v-col>
                                                </v-row>
                                            </v-container>
                                        </v-card-text>
                                    </v-form>
                                </v-card>
                            </v-expansion-panel-content>
                        </v-expansion-panel>

                        <v-expansion-panel>
                            <v-expansion-panel-header v-html="'Plazos de Cancelación de Seguro'"></v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <v-card flat>
                                    <v-form ref="form_plazo_cancelacion_seguro">
                                        <v-card-text>
                                            <v-container fluid grid-list-md>
                                                <v-row dense>
                                                    <v-col cols="12" sm="6">
                                                        <v-row dense>
                                                            <v-col cols="4">
                                                                <v-checkbox label="Por Transferencia:" color="primary"
                                                                    class="mt-3" dense
                                                                    v-model="objCondiciones.activarCancelacionDiasTransferecia" />
                                                            </v-col>
                                                            <v-col cols="8">
                                                                <v-text-field label="Días " color="textbox"
                                                                    v-model="objCondiciones.cancelacionDiasTransferecia"
                                                                    :rules="_.size(objCondiciones.cancelacionDiasTransferecia) > 0 || objCondiciones.activarCancelacionDiasTransferecia ? _.concat(requeridoRegla,numeroRegla) : []"
                                                                    :disabled="!objCondiciones.activarCancelacionDiasTransferecia"
                                                                    outlined dense />
                                                            </v-col>
                                                        </v-row>
                                                    </v-col>
                                                    <v-col cols="12" sm="6">
                                                        <v-row dense>
                                                            <v-col cols="4">
                                                                <v-checkbox label="Por Cheque:" color="primary" class="mt-3"
                                                                    dense
                                                                    v-model="objCondiciones.activarCancelacionDiasCheque" />
                                                            </v-col>
                                                            <v-col cols="8">
                                                                <v-text-field label="Días " color="textbox" dense
                                                                    v-model="objCondiciones.cancelacionDiasCheque"
                                                                    :rules="_.size(objCondiciones.cancelacionDiasCheque) > 0 || objCondiciones.activarCancelacionDiasCheque ? _.concat(requeridoRegla,numeroRegla) : []"
                                                                    :disabled="!objCondiciones.activarCancelacionDiasCheque"
                                                                    outlined />
                                                            </v-col>
                                                        </v-row>
                                                    </v-col>
                                                </v-row>
                                            </v-container>
                                        </v-card-text>
                                    </v-form>
                                </v-card>
                            </v-expansion-panel-content>
                        </v-expansion-panel>

                        <v-expansion-panel>
                            <v-expansion-panel-header v-html="'Plazos de Exclusión de Seguro'"></v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <v-card flat>
                                    <v-card-text>
                                        <v-form ref="form_plazo_exclusion_seguro">
                                            <v-container fluid grid-list-md>
                                                <v-row dense>
                                                    <v-col cols="12" sm="6">
                                                        <v-row dense>
                                                            <v-col cols="4">
                                                                <v-checkbox label="Por Transferencia:" color="primary"
                                                                    class="mt-3" dense
                                                                    v-model="objCondiciones.activarExclusionDiasTransferencia" />
                                                            </v-col>
                                                            <v-col cols="8">
                                                                <v-text-field label="Días " color="textbox"
                                                                    v-model="objCondiciones.exclusionDiasTransferencia"
                                                                    :rules="_.size(objCondiciones.exclusionDiasTransferencia) > 0 || objCondiciones.activarExclusionDiasTransferencia ? _.concat(requeridoRegla,numeroRegla) : []"
                                                                    :disabled="!objCondiciones.activarExclusionDiasTransferencia"
                                                                    outlined dense />
                                                            </v-col>
                                                        </v-row>
                                                    </v-col>
                                                    <v-col cols="12" sm="6">
                                                        <v-row dense>
                                                            <v-col cols="4">
                                                                <v-checkbox label="Por Cheque:" class="mt-3" color="primary"
                                                                    dense
                                                                    v-model="objCondiciones.activarExclusionDiasCheque" />
                                                            </v-col>
                                                            <v-col cols="8">
                                                                <v-text-field label="Días " color="textbox"
                                                                    v-model="objCondiciones.exclusionDiasCheque"
                                                                    :rules="_.size(objCondiciones.exclusionDiasCheque) > 0 || objCondiciones.activarExclusionDiasCheque ? _.concat(requeridoRegla,numeroRegla) : []"
                                                                    :disabled="!objCondiciones.activarExclusionDiasCheque"
                                                                    outlined dense />
                                                            </v-col>
                                                        </v-row>
                                                    </v-col>
                                                </v-row>
                                            </v-container>
                                        </v-form>
                                    </v-card-text>
                                </v-card>
                            </v-expansion-panel-content>
                        </v-expansion-panel>

                        <v-expansion-panel>
                            <v-expansion-panel-header v-html="'Plazos de Gestión de un Siniestro con la Compañía Aseguradora'"></v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <v-card flat>
                                    <v-card-text>
                                        <v-form ref="form_plazo_gestion_siniestro">
                                            <v-container fluid grid-list-md>
                                                <v-row dense>
                                                    <v-col cols="4">
                                                        <v-text-field label="Días de Gestión " color="textbox"
                                                            v-model="objCondiciones.siniestroDiasGestion"
                                                            :rules="_.size(objCondiciones.siniestroDiasGestion) > 0  ? _.concat(requeridoRegla,numeroRegla) : []"
                                                            outlined dense />
                                                    </v-col>
                                                </v-row>
                                            </v-container>
                                        </v-form>
                                    </v-card-text>
                                </v-card>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                        
                        <v-expansion-panel>
                            <v-expansion-panel-header v-html="'Plazos de Inclusión, Exclusión y Cancelación de Seguro'"></v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <v-card flat>
                                    <v-card-text>
                                        <v-form ref="form_plazo_dias_movimiento_seguro">
                                            <v-container fluid grid-list-md>
                                                <v-row dense>
                                                    <v-col cols="12" sm="4">
                                                         <v-text-field label="Días Inclusión" color="textbox"
                                                                    v-model="objCondiciones.inclusionDiasRegla"
                                                                    :rules="_.concat(requeridoRegla,numeroRegla)"
                                                                    outlined dense />
                                                    </v-col>
                                                    <v-col cols="12" sm="4">
                                                        <v-text-field label="Días Exclusión" color="textbox"
                                                                    v-model="objCondiciones.exclusionDiasRegla"
                                                                    :rules="_.concat(requeridoRegla,numeroRegla)"
                                                                    outlined dense />
                                                    </v-col>
                                                    <v-col cols="12" sm="4">
                                                        <v-text-field label="Días Cancelación" color="textbox"
                                                                    v-model="objCondiciones.cancelacionDiasRegla"
                                                                    :rules="_.concat(requeridoRegla,numeroRegla)"
                                                                    outlined dense />
                                                    </v-col>
                                                </v-row>
                                            </v-container>
                                        </v-form>
                                    </v-card-text>
                                </v-card>
                            </v-expansion-panel-content>
                        </v-expansion-panel>

                        <v-expansion-panel>
                            <v-expansion-panel-header v-html="'Texto del Término de Condición en una Venta'"></v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <v-card flat>
                                    <v-card-text>
                                        <v-form ref="form_termino_venta">
                                            <v-container fluid grid-list-md>
                                                <v-row dense>
                                                    <v-col cols="12">
                                                        <v-textarea color="textbox" no-resize
                                                            v-model="objCondiciones.textoTerminoCondicionVenta"
                                                            :value="objCondiciones.textoTerminoCondicionVenta" outlined dense
                                                            :rules="requeridoRegla" />
                                                    </v-col>
                                                </v-row>
                                            </v-container>
                                        </v-form>
                                    </v-card-text>
                                </v-card>
                            </v-expansion-panel-content>
                        </v-expansion-panel>

                        <v-expansion-panel>
                            <v-expansion-panel-header v-html="'Texto del Término de Condición en una Inclusión'"></v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <v-card flat>
                                    <v-card-text>
                                        <v-form ref="form_termino_inclusion">
                                            <v-container fluid grid-list-md>
                                                <v-row dense>
                                                    <v-col cols="12">
                                                        <v-textarea color="textbox" no-resize
                                                            v-model="objCondiciones.textoTerminoCondicionInclusion"
                                                            :value="objCondiciones.textoTerminoCondicionInclusion" outlined dense 
                                                            :rules="requeridoRegla" />
                                                    </v-col>
                                                </v-row>
                                            </v-container>
                                        </v-form>
                                    </v-card-text>
                                </v-card>
                            </v-expansion-panel-content>
                        </v-expansion-panel>

                        <v-expansion-panel>
                            <v-expansion-panel-header v-html="'Texto del Término de Condición en una Exclusión'"></v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <v-card flat>
                                    <v-card-text>
                                        <v-form ref="form_termino_exclusion">
                                            <v-container fluid grid-list-md>
                                                <v-row dense>
                                                    <v-col cols="12">
                                                        <v-textarea color="textbox" no-resize
                                                            v-model="objCondiciones.textoTerminoCondicionExclusion"
                                                            :value="objCondiciones.textoTerminoCondicionExclusion" outlined dense
                                                            :rules="requeridoRegla" />
                                                    </v-col>
                                                </v-row>
                                            </v-container>
                                        </v-form>
                                    </v-card-text>
                                </v-card>
                            </v-expansion-panel-content>
                        </v-expansion-panel>

                        <v-expansion-panel>
                            <v-expansion-panel-header v-html="'Texto del Término de Condición en una Cancelación'"></v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <v-card flat>
                                    <v-card-text>
                                        <v-form ref="form_termino_cancelacion">
                                            <v-container fluid grid-list-md>
                                                <v-row dense>
                                                    <v-col cols="12">
                                                        <v-textarea color="textbox" no-resize
                                                            v-model="objCondiciones.textoTerminoCondicionCancelacion"
                                                            :value="objCondiciones.textoTerminoCondicionCancelacion" outlined dense
                                                            :rules="requeridoRegla" />
                                                    </v-col>
                                                </v-row>
                                            </v-container>
                                        </v-form>
                                    </v-card-text>
                                </v-card>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                        
                        <v-expansion-panel>
                            <v-expansion-panel-header v-html="'Texto del Artículo de Cancelación de Seguro'"></v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <v-card flat>
                                    <v-card-text>
                                        <v-form ref="form_articulo_cancelacion">
                                            <v-container fluid grid-list-md>
                                                <v-row dense>
                                                    <v-col cols="12">
                                                        <v-textarea color="textbox" no-resize
                                                            v-model="objCondiciones.cancelacionTextoArticulo"
                                                            :value="objCondiciones.cancelacionTextoArticulo" outlined dense 
                                                            :rules="requeridoRegla" />
                                                    </v-col>
                                                </v-row>
                                            </v-container>
                                        </v-form>
                                    </v-card-text>
                                </v-card>
                            </v-expansion-panel-content>
                        </v-expansion-panel>

                        <v-expansion-panel>
                            <v-expansion-panel-header v-html="'Texto del Término de AutoInspección'"></v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <v-card flat>
                                    <v-card-text>
                                        <v-form ref="form_termino_autoinspeccion">
                                            <v-container fluid grid-list-md>
                                                <v-row dense>
                                                    <v-col cols="12">
                                                        <v-textarea color="textbox" no-resize
                                                            v-model="objCondiciones.textoTerminoCondicionAutoInspeccion"
                                                            :value="objCondiciones.textoTerminoCondicionAutoInspeccion" outlined dense 
                                                            :rules="requeridoRegla" />
                                                    </v-col>
                                                </v-row>
                                            </v-container>
                                        </v-form>
                                    </v-card-text>
                                </v-card>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="text-right mt-3 mb-3">
                    <v-btn outlined rounded color="danger" class="mr-1" @click="_.set(listGeneral,'listaCondiciones',_.size(objCondiciones) > 0 ? objCondiciones : []);previous()"> Anterior</v-btn>
                    <v-btn rounded dark color="primary" @click="validar" v-html="this.tipoSeguro ? 'Siguiente' : 'Guardar'" :disabled="disabled"></v-btn>
                </v-col>
            </v-row>
        </v-container>
    </v-stepper-content>
</template>

<script>
    export default {
        inject: ['next', 'previous', 'insertarActualizar'],
        props: ['listGeneral', 'cargar', 'objForm', 'parametros'],
        data() {
            return {
                posterior: 0,
                objCondiciones: {},
                objInfReferencia: {},
                formularios: [],
                tipoSeguro: false
            }
        },
        watch: {
            cargar() {
                var objInicio = {
                    activarCancelacionDiasTransferecia: false,
                    activarCancelacionDiasCheque: false,
                    activarExclusionDiasTransferencia: false,
                    activarExclusionDiasCheque: false,
                    idEstado: '1'
                };
                
                this.tipoSeguro = parseInt(this.parametros.idSeguroVehiculo) == parseInt(this.objForm.idSeguro) ? true : false;
                this.objInfReferencia.productoCredito = this.objForm.productoCredito;
                this.posterior = 0;
                // Seguro de Vehículo
                if (this.tipoSeguro && this.objInfReferencia.productoCredito) {
                    this.formularios = [
                                        { p: 0, t: 'form_informacion_referencia' },
                                        { p: 1, t: 'form_plazo_cancelacion_seguro' },
                                        { p: 2, t: 'form_plazo_exclusion_seguro' },
                                        { p: 3, t: 'form_plazo_gestion_siniestro' },
                                        { p: 4, t: 'form_plazo_dias_movimiento_seguro' },
                                        { p: 5, t: 'form_termino_venta' },
                                        { p: 6, t: 'form_termino_inclusion' },
                                        { p: 7, t: 'form_termino_exclusion' },
                                        { p: 8, t: 'form_termino_cancelacion' },
                                        { p: 9, t: 'form_articulo_cancelacion' },
                                        { p: 10, t: 'form_termino_autoinspeccion' },
                    ];

                    if (this.cargar && _.size(this.listGeneral.listaCondiciones) == 0) {
                        var request = [this.onListarCondiciones(), this.onListarInformacionAdicional()];

                        Promise.all(request).catch((e) => {
                            mensajesAlerta(e, 'E')
                        });
                    }
                }
                // Otros tipos de Seguro                                  
                else {
                    this.formularios = [
                                        { p: 0, t: 'form_plazo_cancelacion_seguro' },
                                        { p: 1, t: 'form_plazo_exclusion_seguro' },
                                        { p: 2, t: 'form_plazo_gestion_siniestro' },
                                        { p: 3, t: 'form_plazo_dias_movimiento_seguro' },
                                        { p: 4, t: 'form_termino_venta' },
                                        { p: 5, t: 'form_termino_inclusion' },
                                        { p: 6, t: 'form_termino_exclusion' },
                                        { p: 7, t: 'form_termino_cancelacion' },
                                        { p: 8, t: 'form_articulo_cancelacion' },
                                        { p: 9, t: 'form_termino_autoinspeccion' },
                    ];

                    if (this.cargar && _.size(this.listGeneral.listaCondiciones) == 0)
                        this.onListarCondiciones().catch((e) => {
                            mensajesAlerta(e, 'E')
                        });
                }

                this.objCondiciones = _.size(this.listGeneral.listaCondiciones) > 0 ? this.listGeneral.listaCondiciones : objInicio;
            },
        },
        computed:{
            disabled(){
                return _.size(this.formularios) > (this.posterior + 1) ? true : false;
            }
        },
        methods: {
            onListar(ruta, objeto) {
                return axios.post(`${BASE_URI}${ruta}`, objeto)
                    .then((respuesta) => {
                        if (respuesta.status != 200 && respuesta.statusText != 'OK') throw mensajeEstandar
                            .errorPeticion;
                        if (respuesta.data.existeError) throw respuesta.data.mensaje;
                        if (_.size(respuesta.data.data) == 0)
                            mensajesAlerta(respuesta.data.mensaje, 'I');

                        return respuesta;
                    })
                    .catch((e)=>{
                        return e;
                    });
            },
            onListarCondiciones() {
                var objeto = {
                    opcion: 'LISTAR_CONDICIONES_PRODUCTO',
                    idProducto: this.objForm.idProducto,
                    idEstado: this.objForm.idEstado
                };

                return this.onListar('administrador/producto/listar', objeto)
                            .then((respuesta) => {
                                if (_.size(_.get(respuesta,['data','data'],[])) > 0) {
                                    var objeto = _.map(respuesta.data.data, (o) => { 
                                                    o.activarCancelacionDiasTransferecia = _.size(o.cancelacionDiasTransferecia) > 0 ? true : false;
                                                    o.activarCancelacionDiasCheque = _.size(o.cancelacionDiasCheque) > 0 ? true : false;
                                                    o.activarExclusionDiasTransferencia = _.size(o.exclusionDiasTransferencia) > 0 ? true : false;
                                                    o.activarExclusionDiasCheque = _.size(o.exclusionDiasCheque) > 0 ? true : false;
                                                    return o;
                                                });

                                    this.$set(this, 'objCondiciones', _.merge({}, this.objCondiciones, objeto[0]));
                                }
                                return respuesta;
                            });
            },
            onListarInformacionAdicional() {
                var objeto = {
                    opcion: 'LISTAR_INFORMACION_VEHICULO',
                    idProducto: this.objForm.idProducto,
                    idEstado: this.objForm.idEstado
                };

                return this.onListar('administrador/producto/listar', objeto)
                            .then((respuesta) => {
                                if (_.size(_.get(respuesta,['data','data'],[])) > 0) {
                                    var objeto = _.map(respuesta.data.data, (o) => {
                                                        o.porcValorRecomendadoMin = _.size(o.porcValorRecomendadoMin) > 0 ? _ .toString(parseInt(o.porcValorRecomendadoMin)) : null;
                                                        o.porcValorRecomendadoMax = _.size(o.porcValorRecomendadoMax) > 0 ? _.toString(parseInt(o.porcValorRecomendadoMax)) : null;
                                                        return o;
                                                    });
                                    this.$set(this, 'objInfReferencia', objeto[0]);
                                }
                            });
            },
            validar() {
                var band = true;
                this.posterior = 0;
                for (let index = 0; index < this.formularios.length; index++) {
                    if(!_.isUndefined(this.$refs[this.formularios[index].t])){
                        if (!this.$refs[this.formularios[index].t].validate()) {
                            band = false;
                            this.$set(this, 'posterior', this.formularios[index].p);
                            mensajesAlerta(mensajeEstandar.corregirInformacion, 'I');
                            break;
                        }
                    }
                    ++this.posterior;
                }
                
                if(band && this.validarObjReferencia(''))
                    this.insertarActualizarProducto();
            },
            insertarActualizarProducto(){
                _.set(this.listGeneral, 'listaVehiProducto', this.objInfReferencia);
                _.set(this.listGeneral, 'listaCondiciones', this.objCondiciones);

                // console.log(this.listGeneral.listaVehiProducto, this.listGeneral.listaCondiciones);
                if (this.tipoSeguro)
                    this.next();
                else
                    this.insertarActualizar();
            },
            validarObjReferencia(nombreForm) {
                var validacion = false;

                if (this.tipoSeguro) {
                    var valorVehiculoMin = !_.isUndefined(this.objInfReferencia.valorVehiculoMin) ? _.toNumber(this.objInfReferencia.valorVehiculoMin) : 0;
                    var valorVehiculoMax = !_.isUndefined(this.objInfReferencia.valorVehiculoMax) ? _.toNumber(this.objInfReferencia.valorVehiculoMax) : 0;
                    var porcValorRecomendadoMin = !_.isUndefined(this.objInfReferencia.porcValorRecomendadoMin) ? _.toNumber(this.objInfReferencia.porcValorRecomendadoMin) : 0;
                    var porcValorRecomendadoMax = !_.isUndefined(this.objInfReferencia.porcValorRecomendadoMax) ? _.toNumber(this.objInfReferencia.porcValorRecomendadoMax) : 0;

                    if (valorVehiculoMin <= valorVehiculoMax && porcValorRecomendadoMin <= porcValorRecomendadoMax)
                        validacion = true;
                    else {
                        this.posterior = 0;
                        mensajesAlerta(mensajeEstandar.corregirInformacion, 'I');
                    }
                } else {
                    validacion = true;
                }

                return validacion;
            }
        }
    }
</script>